import { ReactElement } from 'react'

import { useQuotesList } from '../../context/quotesList'
import { QuotesListDataProvider } from '../../context/quotesListData'
import { QuotesSummary } from '../QuotesSummary'
import { QuotesTable } from '../QuotesTable'
import { QuotesTableActions } from '../QuotesTableActions'

export const QuotesListWithSummary = (): ReactElement => {
  const { options } = useQuotesList()

  return (
    <>
      {options.showSummary && <QuotesSummary />}
      <QuotesListDataProvider>
        <QuotesTableActions />
        <QuotesTable />
      </QuotesListDataProvider>
    </>
  )
}
